import React from "react";
import './SafetyPolicy.css'

function Sefety() {
  return (
  
    <div className='saf'>
      <div className='safp'>
        <p>Safety Policy</p>
        <div>
            {/* <p className='p2'>Swajit Engineering Pvt.Ltd. > Safety Policy</p> */}
        </div>
        <div className="safb">

        </div>
      </div>
        </div>
  );
}

export default Sefety;
